"use client";

import { EditorialPage } from "@utils/damac/api";
import { FC, Fragment, useEffect, useRef, useState } from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";

import ForSalesCard from "./ForSalesCard";

const ForSalesListing: FC<{ forSalesListingPage: EditorialPage[] }> = ({ forSalesListingPage }) => {
  return (
    <>
      <div className="py-l">
        <div className="px-l md:p-0 md:w-20\/24 md:mx-auto md:grid md:grid-cols-4 md:gap-l">
          {forSalesListingPage?.length > 0 &&
            forSalesListingPage?.map((page, index) => (
              <ForSalesCard key={index} title={page.listCardTitle} description={page.cardDescription} image={page.thumbnail} slug={page.slug} />
            ))}
        </div>
      </div>
    </>
  );
};

export default ForSalesListing;
